import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=68c39b10&"
import script from "./Mobile.vue?vue&type=script&lang=js&"
export * from "./Mobile.vue?vue&type=script&lang=js&"
import style0 from "./Mobile.vue?vue&type=style&index=0&id=68c39b10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports